import { Component, OnInit } from '@angular/core';
import { CategoricalTraitInfo, CategoricalValue, TraitCondition } from '../../trait.reference.model';
import { MultiTraitQueryContext } from '../../multi-trait-query-context';
import { AlertService } from '../../../shared/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { TraitFilterContext } from '../trait-filter-context';
import { Weight } from '../../../shared/query/model/weight.model';


@Component({
    selector: 'jhi-categorical-traits-pane',
    templateUrl: 'categorical-traits-pane.component.html'
})
export class CategoricalTraitsPaneComponent implements OnInit {
    conditionOptions = [
        { label: 'multi-trait-query.condition.categorical.drop-trait', value: TraitCondition.DROP_TRAIT },
        { label: 'multi-trait-query.condition.categorical.keep-all', value: TraitCondition.KEEP_ALL },
        { label: 'multi-trait-query.condition.categorical.in', value: TraitCondition.IN },
        { label: 'multi-trait-query.condition.categorical.not.in', value: TraitCondition.NOT_IN }
    ];
    traitWeightOptions = [
        { label: 'multi-trait-query.environment.weight.important', value: Weight.IMPORTANT },
        { label: 'multi-trait-query.environment.weight.critical', value: Weight.CRITICAL },
        { label: 'multi-trait-query.environment.weight.desirable', value: Weight.DESIRABLE },
        { label: 'multi-trait-query.environment.weight.ignored', value: Weight.IGNORED }
    ];
    isLoading: boolean;
    classColumHeader = '';
    validationError: string;
    headerValues: CategoricalValue[] = [];
    protected readonly TraitCondition = TraitCondition;

    constructor(private alertService: AlertService,
                public traitFilterContext: TraitFilterContext,
                public queryContext: MultiTraitQueryContext,
                private translateService: TranslateService) {
    }

    async ngOnInit() {
        this.classColumHeader = this.translateService.instant('multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.table.header.class');
        if (this.traitFilterContext.categoricalTraits.length > 0) {
            const categoricalTraitInfo = this.traitFilterContext.categoricalTraits.reduce((prev, curr) => {
                return (curr.values?.length || 0) > (prev.values?.length || 0) ? curr : prev;
            });
            this.headerValues = categoricalTraitInfo.values;
        }
    }

    isLimitsDisabled(categoricalTrait: CategoricalTraitInfo): boolean {
        return categoricalTrait.condition === TraitCondition.DROP_TRAIT ||
            categoricalTrait.condition === TraitCondition.KEEP_ALL;
    }

    showCategoricalHead(value: CategoricalValue): string {
        return this.classColumHeader + value.name;
    }

    showCategoricalValue(categoricalValue: CategoricalValue ,values: CategoricalValue[]): string {
        if (values.length === 0) {
            return '';
        }
        const value = values.find(v => v.name === categoricalValue.name);
        return value ? value.name + ' (' + value.count + ')' : '';
    }

    showMessageError(categoricalTrait: any) {
        if (categoricalTrait.limits.trim() === '') {
            return this.translateService.instant('multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.error.limits.empty.value');
        } else if (categoricalTrait.condition === TraitCondition.IN || categoricalTrait.condition === TraitCondition.NOT_IN) {
            return this.translateService.instant('multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.error.limits.exceeded.limits');
        } else {
            return this.translateService.instant('multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.error.limits.invalid.value');
        }
    }

    selectedCondition(categoricalTrait: CategoricalTraitInfo) {
        if (categoricalTrait.condition === TraitCondition.DROP_TRAIT) {
            categoricalTrait.priority = Weight.IGNORED;
        } else {
            categoricalTrait.priority = Weight.IMPORTANT;
        }
    }
}
